import {apiRouteConstants} from './api-route.constants';
import {navigationConstants} from './navigation.constants';
import {submissionStateConstants} from './submission-state.constants'; 
import {styleClassConstants} from './style-class.constants'; 
import { uiRouteConstants } from './ui-route.constants';
import { validationRuleConstants } from './validation-rule.constants';
import { importDataConstants } from './import-data.constants';
import { managedContentConstants } from './managed-content.constants';

export const constants = {
  apiRoutes: apiRouteConstants,  
  navigation: navigationConstants, 
  submissionStates: submissionStateConstants, 
  styleClasses: styleClassConstants,   
  uiRoutes: uiRouteConstants,
  importData: importDataConstants,
  managedContent: managedContentConstants,
  validationRules: validationRuleConstants,
};
